import type { ApiFailure } from '../../lib/http/errors';

export function fieldErrorOf(failure: ApiFailure | null, field: string): string | null {
  if (failure === null || failure.kind !== 'invalid') return null;
  return failure.field === field ? failure.message : null;
}

/** The `aria-invalid`/`aria-describedby` pair an `<input>` owes its
 *  `<FieldError id={errorId}>` sibling whenever `fieldErrorOf` names this
 *  field: rendering the error without this leaves it visible and
 *  unannounced. Every caller building fields around `fieldErrorOf` should
 *  spread this onto the control rather than re-deriving it by hand. */
export function fieldControlProps(
  failure: ApiFailure | null,
  field: string,
  errorId: string,
): { 'aria-invalid'?: true; 'aria-describedby'?: string } {
  if (fieldErrorOf(failure, field) === null) return {};
  return { 'aria-invalid': true, 'aria-describedby': errorId };
}
